(function() { module.exports = this["wp"]["element"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","element"]}
// module id = 2
// module chunks = 0 1 2